/**
 * Created by mohit.chavda on 3/9/2017.
 */
export class State {

  get label():string
  {
    //return this.stateCode;
    if(this.stateID <= 0)
    return this.stateCode;
    else
      return this.stateCode + " - " + this.stateName;
  };
  get value():string
  {
    return this.stateCode;
  };

  stateID:number;
  stateCode:string;
  stateName:string;
}



// WEBPACK FOOTER //
// ./src/app/shared/State.ts